export default __webpack_public_path__ + "static/consumerBannerNew-7e0e4b89ea1710004314ff7d6c527a92.png";